import {Component, OnDestroy, OnInit} from '@angular/core';
import {Account} from '../shared/models/account';
import {SessionService} from '../core/service/session.service';
import {AppInitService} from '../core/service/app-init.service';
import {CommonService} from '../core/service/common.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, OnDestroy {
  showPassword = false;
  account = new Account();

  constructor(private sessionService: SessionService,
              private appInitService: AppInitService,
  private commonService: CommonService,) {
    this.account.email = commonService.getParamValueQueryString('email') ?? '';
  }

  /**
   *
   */
  ngOnInit(): void {
  }

  /**
   *
   */
  async ngOnDestroy() {
    await this.appInitService.Init();
  }

  /**
   *
   * @param $event
   */
  submitLogin($event: any) {
    $event.preventDefault();
    this.sessionService.loginWithEmailAndPassword(this.account);
  }

  /**
   *
   * @param passwordResetEmail
   */
  sendPasswordResetEmail(passwordResetEmail: string) {
    this.sessionService.sendPasswordResetEmail(passwordResetEmail);
  }
}
